module.exports = __webpack_public_path__ + "static/media/icon_file.e9b3fa5e.svg";